module.exports = __webpack_public_path__ + "img/page_img3.61dd485e.jpg";